import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90fb9178"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Welcome "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("to "),
  /*#__PURE__*/_createElementVNode("b", null, "your"),
  /*#__PURE__*/_createTextVNode(" account")
], -1))
const _hoisted_2 = { class: "auth--forgot-password m-bottom-30" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Forgot password?")
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Need a IMDatacenter account? ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Join Us")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_base_input, {
      title: "Email Address",
      bind: { autocomplete: 'email' },
      placeholder: "grace.soto@example.com",
      value: _ctx.user.username,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.username) = $event)),
      focus: ""
    }, null, 8, ["value"]),
    _createVNode(_component_base_input, {
      title: "Password",
      type: "password",
      placeholder: "Enter your password here",
      bind: { autocomplete: 'current-password' },
      errors: _ctx.errors,
      value: _ctx.user.password,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password) = $event))
    }, null, 8, ["errors", "value"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "identify" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["btn fill t-t-u m-bottom-20", { 'spinner': _ctx.loader }]),
      disabled: _ctx.loader,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
    }, " Log In ", 10, _hoisted_4),
    _createElementVNode("p", null, [
      _hoisted_5,
      _createVNode(_component_router_link, { to: "sign-up" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ], 64))
}